import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, object = auth, false = not auth
  const [loading, setLoading] = useState(true);
  const [activeCompany, setActiveCompanyState] = useState(() => sessionStorage.getItem("travel_active_company") || "");

  const setActiveCompany = (company) => {
    sessionStorage.setItem("travel_active_company", company);
    setActiveCompanyState(company);
  };

  useEffect(() => {
    const token = localStorage.getItem("cosma_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("cosma_token");
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const refreshUser = async () => { const res = await api.get("/auth/me"); setUser(res.data); return res.data; };

  const login = async (email, password, remember) => {
    const res = await api.post("/auth/login", { email, password, remember });
    localStorage.setItem("cosma_token", res.data.token);
    const company = res.data.user.active_company || res.data.user.company;
    sessionStorage.setItem("travel_active_company", company);
    setActiveCompanyState(company);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_) {
      // Il logout locale deve completarsi anche se la chiamata di revoca fallisce.
    }
    localStorage.removeItem("cosma_token");
    sessionStorage.removeItem("travel_active_company");
    setActiveCompanyState("");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading, activeCompany, setActiveCompany, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export const ROLE_LABEL = {
  dipendente: "Dipendente",
  responsabile: "Responsabile",
  amministratore: "Amministratore",
};
